module.exports = "data:image/gif;base64,R0lGODlhAwAEAJEAAAAAAP///4wVFf///yH5BAEAAAMALAAAAAADAAQAAAIDlI9WADs="